import Shepherd from "shepherd.js";

/**
 * Checks tourTraker in localStorage and return `true` if the tour has been viewed before
 * @param {String} tourName
 */
export const tourChecker = (tourName) => {
  let tourTracker = JSON.parse(localStorage.getItem("tourTracker") || "{}");
  return !!tourTracker[tourName];
};

/**
 * Marks the tour complete by updating the tourTracker in localStorage
 * @param {String} tourName
 */
export const markTourComplete = (tourName) => {
  console.warn(`Completed ${tourName} tour`);
  let tourTracker = JSON.parse(localStorage.getItem("tourTracker") || "{}");
  tourTracker = {
    ...tourTracker,
    [tourName]: true,
  };
  localStorage.setItem("tourTracker", JSON.stringify(tourTracker));
};

/**
 * Adds the tour to queue if there's any other tour is progress, or starts it immediately.
 * @param {Shepherd.Tour} tour
 * @param {String} tourName
 */
export const addTourToQueue = (tour, tourName) => {
  // Check if there's another tour is progress:
  if (Shepherd.activeTour) {
    // If there's another tour, add current tour to queue:
    console.warn(`Added ${tourName} tour to the queue`);
    Shepherd.activeTour.on("complete", () => {
      tour.start();
      Shepherd.activeTour.on("complete", () => markTourComplete(tourName));
    });
  } else {
    // Else just start the current tour right away:
    console.warn(`Started ${tourName} tour`);
    tour.start();
    Shepherd.activeTour.on("complete", () => markTourComplete(tourName));
  }
};
